module.exports = __webpack_public_path__ + "img/BZ.ee4ef22c.svg";